// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// 路由
import router from './router'
//状态管理
import store from './store/store.js';
//全局过滤器
import './util/filters.js';
import 'styles/reset.css';
// import 'styles/load.css';
//上拉加载 下拉刷新
import VueScroller from 'vue-scroller';
Vue.use(VueScroller);
//自定义插件 - 警告框
import Message from '@/components/common/message';
Vue.use(Message);
//自定义插件 - 登录插件
import Login from '@/components/common/login';
Vue.use(Login);
//自定义插件 - 下载app
import Download from '@/components/common/download';
Vue.use(Download);
//图片的懒加载
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);
//气泡
import VueTippy, { TippyComponent } from 'vue-tippy';
Vue.use(VueTippy);
Vue.component('tippy', TippyComponent);
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

Vue.config.productionTip = false;

// import Vconsole from 'vconsole';
// let vConsole = new Vconsole();
// export default vConsole

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    setTimeout(() => {
      document.dispatchEvent(new Event('render-event'))
    }, 1000)
  }
})



// WEBPACK FOOTER //
// ./src/main.js